import ExecAPI from 'appRoot/api/api';

export function SendLoginRequestToEmail(user)
{
	return ExecAPI("Auth/SendLoginRequestToEmail", { user });
}
export function LoginWithOneTimeCode(user, code)
{
	return ExecAPI("Auth/LoginWithOneTimeCode", { user, code });
}